import React from 'react';
import { Checkbox, CheckboxProps } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { colors } from 'spw-theme';

const useStyles = makeStyles({
  checkbox: {
    padding: '3px',
    '&:hover': {
      backgroundColor: 'unset',
    },
  },
});

const defaultCheckedIcon = (fill: string = colors.mainBlue) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16 0H2C0.89 0 0 0.9 0 2V16C0 17.1 0.89 18 2 18H16C17.11 18 18 17.1 18 16V2C18 0.9 17.11 0 16 0ZM7 14L2 9L3.41 7.59L7 11.17L14.59 3.58L16 5L7 14Z"
      fill={fill}
    />
  </svg>
);

const defaultUncheckedIcon = (fill: string = colors.mainBlue) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16 2V16H2V2H16ZM16 0H2C0.9 0 0 0.9 0 2V16C0 17.1 0.9 18 2 18H16C17.1 18 18 17.1 18 16V2C18 0.9 17.1 0 16 0Z"
      fill={fill}
    />
  </svg>
);

type Props = CheckboxProps;

const BaseCheckbox = ({
  className,
  disabled,
  checkedIcon = defaultCheckedIcon(
    disabled ? colors.disabledCheckbox : colors.mainBlue
  ),
  icon = defaultUncheckedIcon(
    disabled ? colors.disabledCheckbox : colors.mainBlue
  ),
  ...props
}: Props) => {
  const classes = useStyles();

  return (
    <Checkbox
      {...props}
      className={`${className ?? ''} ${classes.checkbox}`}
      disabled={disabled}
      checkedIcon={checkedIcon}
      icon={icon}
    />
  );
};

export default BaseCheckbox;
